<!--
  Created 29.10.2023
  Date formatter component
  Displays a date range in a human readable format
-->
<template>
  <template v-if="rawReturn">
    {{ date }}
  </template>
  <time v-else>{{ date }}</time>
</template>
<script setup>
import moment from 'moment-timezone';
import {
  computed,
} from 'vue';
import { initiateLanguageLocale } from '@/utils';

const props = defineProps({
  dateTime: {
    type: String,
    required: true,
  },
  rawReturn: {
    type: Boolean,
    required: false,
    default: false,
  },
  dateTimeStyle: {
    type: String,
    required: false,
    default: '',
    validator: (value) => ['full', 'long', 'medium', 'short', ''].includes(value),
  },
  dateStyle: {
    type: String,
    required: false,
    default: '',
    validator: (value) => ['full', 'long', 'medium', 'short', 'tiny', ''].includes(value),
  },
  timeStyle: {
    type: String,
    required: false,
    default: '',
    validator: (value) => ['full', 'long', 'medium', 'short', ''].includes(value),
  },
});

const dateTimeStyleMap = {
  full: 'LLLL', // søndag 29. oktober 2023 kl. 21:33
  long: 'llll', // sø. 29. okt. 2023 kl. 21:33
  medium: 'LLL', // 29. oktober 2023 kl. 21:33
  short: 'lll', // 29. okt. 2023 kl. 21:33
  tiny: 'L LT', // 29.10.2023 21:33
};

const dateStyleMap = {
  full: 'LL', // 29. oktober 2023
  long: 'll', // 29. okt. 2023
  medium: 'L', // 29.10.2023
  short: 'DD.MM', // 29.10
  tiny: 'D', // 29
};

const timeStyleMap = {
  full: 'LTS', // 21:33:14
  long: 'LTS', // 21:33:14
  medium: 'LT', // 21:33
  short: 'LT', // 21:33
  tiny: 'L', // 21
};

const format = computed(() => {
  if (props.timeStyle) {
    return timeStyleMap[props.timeStyle];
  }
  if (props.dateStyle) {
    return dateStyleMap[props.dateStyle];
  }
  if (props.dateTimeStyle) {
    return dateTimeStyleMap[props.dateTimeStyle];
  }

  return dateTimeStyleMap.full;
});

initiateLanguageLocale();

const date = computed(() => moment(props.dateTime).format(format.value.toString()));

</script>
